import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const WalletIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M20.25 6H5.25C5.05109 6 4.86032 5.92098 4.71967 5.78033C4.57902 5.63968 4.5 5.44891 4.5 5.25C4.5 5.05109 4.57902 4.86032 4.71967 4.71967C4.86032 4.57902 5.05109 4.5 5.25 4.5H18C18.1989 4.5 18.3897 4.42098 18.5303 4.28033C18.671 4.13968 18.75 3.94891 18.75 3.75C18.75 3.55109 18.671 3.36032 18.5303 3.21967C18.3897 3.07902 18.1989 3 18 3H5.25C4.65326 3 4.08097 3.23705 3.65901 3.65901C3.23705 4.08097 3 4.65326 3 5.25V17.25C3 17.8467 3.23705 18.419 3.65901 18.841C4.08097 19.2629 4.65326 19.5 5.25 19.5H20.25C20.6478 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V7.5C21.75 7.10218 21.592 6.72064 21.3107 6.43934C21.0294 6.15804 20.6478 6 20.25 6ZM20.25 18H5.25C5.05109 18 4.86032 17.921 4.71967 17.7803C4.57902 17.6397 4.5 17.4489 4.5 17.25V7.37156C4.74082 7.45693 4.9945 7.50037 5.25 7.5H20.25V18ZM15.75 12.375C15.75 12.1525 15.816 11.935 15.9396 11.75C16.0632 11.565 16.2389 11.4208 16.4445 11.3356C16.65 11.2505 16.8762 11.2282 17.0945 11.2716C17.3127 11.315 17.5132 11.4222 17.6705 11.5795C17.8278 11.7368 17.935 11.9373 17.9784 12.1555C18.0218 12.3738 17.9995 12.6 17.9144 12.8055C17.8292 13.0111 17.685 13.1868 17.5 13.3104C17.315 13.434 17.0975 13.5 16.875 13.5C16.5766 13.5 16.2905 13.3815 16.0795 13.1705C15.8685 12.9595 15.75 12.6734 15.75 12.375Z'
        fill={color}
      />
    </svg>
  )
})

WalletIcon.displayName = 'WalletIcon'
